'use client';

import React from 'react';
import Link from 'next/link';
import Header from '@/components/Header';

const aboutSections = [
  { id: 'about', label: 'About Us', href: '/about' },
  { id: 'history', label: 'History', href: '/about/history' },
  { id: 'mission', label: 'Mission', href: '/about/mission' },
  { id: 'vision', label: 'Vision', href: '/about/vision' },
  { id: 'membership', label: 'Membership', href: '/about/membership' },
  { id: 'quality', label: 'Quality Management', href: '/about/quality-management' },
  { id: 'ethics', label: 'Business Ethics', href: '/about/business-ethics' },
];

export default function VisionPage() {
  return (
    <>
      <Header />
      <main className="min-h-screen" style={{ background: '#F4F6F9', color: '#0F2340' }}>
        {/* Hero */}
        <div className="relative pt-32 pb-16 px-6" style={{ background: 'linear-gradient(180deg, #0F2340 0%, #1A3558 100%)', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div className="max-w-5xl mx-auto">
            <Link href="/about" className="inline-flex items-center gap-2 text-sm font-body mb-4 transition-colors" style={{ color: '#7EB8F7' }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#FFFFFF'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#7EB8F7'}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 5l-7 7 7 7" /></svg>
              The Company
            </Link>
            <p className="text-xs uppercase tracking-widest font-body mb-3" style={{ color: '#7EB8F7' }}>World Transport Overseas</p>
            <h1 className="text-4xl lg:text-5xl font-bold font-body mb-4" style={{ color: '#FFFFFF' }}>Vision</h1>
            <p className="text-lg font-body max-w-2xl" style={{ color: 'rgba(200,216,240,0.7)' }}>Vision 2030 — Becoming a truly global logistics company.</p>
          </div>
        </div>
        {/* Sub-nav */}
        <div className="sticky top-20 z-30 px-6 py-3" style={{ background: 'rgba(255,255,255,0.97)', borderBottom: '1px solid rgba(15,35,64,0.1)', backdropFilter: 'blur(12px)' }}>
          <div className="max-w-5xl mx-auto flex flex-wrap gap-1">
            {aboutSections?.map((s) => (
              <Link key={s?.id} href={s?.href}
                className="px-4 py-2 rounded-full text-sm font-body font-medium transition-all duration-200"
                style={s?.id === 'vision'
                  ? { background: '#1B6B8A', color: '#FFFFFF', border: '1px solid rgba(27,107,138,0.5)' }
                  : { background: 'transparent', color: '#3A5070', border: '1px solid rgba(15,35,64,0.15)' }}
                onMouseEnter={(e) => { if (s?.id !== 'vision') { e.currentTarget.style.background = 'rgba(27,107,138,0.1)'; e.currentTarget.style.color = '#0F2340'; } }}
                onMouseLeave={(e) => { if (s?.id !== 'vision') { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#3A5070'; } }}
              >{s?.label}</Link>
            ))}
          </div>
        </div>
        {/* Content */}
        <div className="max-w-4xl mx-auto px-6 py-16">
          <div className="rounded-3xl p-10 mb-12" style={{ background: '#0F2340', border: '1px solid rgba(27,107,138,0.3)' }}>
            <p className="text-xl lg:text-2xl font-body leading-relaxed" style={{ color: '#FFFFFF' }}>
              "World Transport Overseas aspires to be a distinguished leader in sea and air cargo transportation, renowned for our innovation and cutting-edge logistics solutions."
            </p>
          </div>

          <div className="space-y-5 text-base font-body leading-relaxed mb-12" style={{ color: '#3A5070' }}>
            <p>
              We aim to combine extensive global geographical coverage with meticulous control of the supply chain, ensuring seamless and efficient service delivery. By continuously embracing technological advancements and fostering a culture of excellence, we strive to set new standards in the logistics industry, providing unparalleled value to our clients and stakeholders.
            </p>
            <p>
              As part of its long-term strategy, <strong style={{ color: '#1B6B8A' }}>Vision 2030</strong>, World Transport Overseas aims to become a truly global logistics company by 2030, investing actively in digitalization, automation, and sustainable development across all operations.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-6">
            {[
              { title: 'Global Coverage', desc: 'Extensive geographical coverage combined with meticulous supply chain control.' },
              { title: 'Innovation', desc: 'Continuously embracing technological advancements and cutting-edge logistics solutions.' },
              { title: 'Vision 2030', desc: 'Strategic plan to become a truly global logistics company by 2030.' },
              { title: 'Sustainability', desc: 'Investing in sustainable development across all operations.' },
            ]?.map((item) => (
              <div key={item?.title} className="rounded-2xl p-6" style={{ background: '#FFFFFF', border: '1px solid rgba(15,35,64,0.1)', boxShadow: '0 2px 8px rgba(15,35,64,0.06)' }}>
                <h3 className="text-base font-bold font-body mb-1" style={{ color: '#0F2340' }}>{item?.title}</h3>
                <p className="text-sm font-body leading-relaxed" style={{ color: '#3A5070' }}>{item?.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </main>
    </>
  );
}
